export const OC_SLIDER_PROPS = {
    sliderType: {
        // used to determine default slide widths
        type: String,
        default: 'product',
    },
    desktopSliderActive: {
        // determines if the slider arrows are functioning
        type: Boolean,
        default: true,
    },
    mobileSwipingActive: {
        // if disabled mobile also has arrows. Default is native swiping
        type: Boolean,
        default: true,
    },
    itemsPerSlide: {
        // how many full slides are visible
        type: Number,
        default: 1,
    },
    fixedSlideWidth: {
        type: Number,
        default: 0,
    },
    arrowsOffset: {
        // used to move the arrows a bit up or down
        type: Number,
        default: 0,
    },
    arrowColor: {
        // expects a text-* tailwind class to change the arrow color
        type: String,
        default: 'text-black',
    },
    currentSlide: {
        // which index is the current slide
        type: Number,
        default: 0,
    },
    refreshSlider: {
        // use a timestamp to refresh the slider (used when expanding slider)
        type: Number,
        default: 0,
    },
    nonRelative: {
        // removes css relative from slider
        type: Boolean,
        default: false,
    },
    noGaps: {
        // row with gaps or not
        type: Boolean,
        default: false,
    },
}

export const DEFAULT_TILE_SIZES = {
    brand: {
        xs: 1.2,
        sm: 2.5,
        md: 2.8,
    },
    product: {
        xs: 1.6,
        sm: 2.2,
        md: 3.3,
    },
    category: {
        xs: 2.2,
        sm: 2.8,
        md: 3.3,
    },
}

export const MORE_FROM_BRAND_SLIDER_FIXED_SIZE = 392
